import { Box, BoxProps } from '@mui/material';
import { CSSProperties, ReactNode, useMemo } from 'react';
import { useAdapterContext } from '../../utils/adapters';

const style: CSSProperties = {
  display: 'contents',
  color: 'unset',
  textDecoration: 'unset',
  outline: 'unset',
  border: 'unset',
  background: 'unset',
  cursor: 'pointer',
} as CSSProperties;

export function HomePageLink({
  children,
  linkProps,
  sx,
}: {
  linkProps?: Partial<MdsAdapterLinkProps>;
} & Pick<BoxProps, 'sx' | 'children'>) {
  const { LinkComponent, homePageLinkProps } = useAdapterContext();
  return useMemo(() => {
    const props = {
      children: (
        <Box component="span" sx={sx}>
          {children}
        </Box>
      ),
      style,
      ...(linkProps ?? homePageLinkProps),
    } satisfies {
      children: ReactNode;
      style: CSSProperties;
    };
    // TS is not able to infer the correct type here due to clashing adapters
    return <LinkComponent {...(props as any)} />;
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LinkComponent, children, ...Object.values(linkProps ?? {}), sx]);
}
